import ProposalReviewer from "../../proposal-reviewer";

export type ProposalReviewerAPIRequestPayload = {
  userId?: string;
  legalEntityId?: string;
  isEditing?: boolean;
  dateApproved?: string;
  customMessage?: string;
};
export default class ProposalReviewerCommand {
  userId?: string;
  legalEntityId?: string;
  isEditing?: boolean;
  dateApproved?: string;
  customMessage?: string;

  public get payload(): ProposalReviewerAPIRequestPayload {
    return {
      userId: this.userId,
      legalEntityId: this.legalEntityId,
      isEditing: this.isEditing,
      dateApproved: this.dateApproved,
      customMessage: this.customMessage,
    };
  }

  constructor(reviewer: ProposalReviewer) {
    if (!reviewer?.entityMember) {
      throw new Error("Reviewer must indicate entity fee schedule is being created for.");
    }
    this.userId = reviewer?.entityMember?.userId.value;
    this.legalEntityId = reviewer?.entityMember?.legalEntityId.value;
    this.isEditing = reviewer?.isEditing;
    this.dateApproved = reviewer?.dateApproved?.toISOString();
    this.customMessage = reviewer?.customMessage;
  }
}
